"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailabilityStatusFieldLogic = void 0;
var availability_status_fieldtype_1 = require("./availability-status.fieldtype");
Object.defineProperty(exports, "AvailabilityStatusFieldLogic", { enumerable: true, get: function () { return availability_status_fieldtype_1.AvailabilityStatusFieldLogic; } });
